import React from "react";
import { BookOpenIcon } from "@heroicons/react/24/outline";
import { LessonI } from "../../../types";

interface LessonsTabContentProps {
  lessons: LessonI[];
  selectedLessonId: string | null;
  onSelectLesson: (lesson: LessonI) => void;
}

const LessonsTabContent: React.FC<LessonsTabContentProps> = ({
  lessons,
  selectedLessonId,
  onSelectLesson,
}) => {
  if (lessons.length === 0) {
    return (
      <div className="p-4 text-center text-gray-500">No unlinked lessons</div>
    );
  }

  return (
    <div className="divide-y">
      {lessons.map((lesson: LessonI) => (
        <div
          key={lesson._id}
          className={`p-4 cursor-pointer hover:bg-gray-50 transition-colors ${
            selectedLessonId === lesson._id
              ? "bg-blue-50 border-l-4 border-blue-500"
              : ""
          }`}
          onClick={() => onSelectLesson(lesson)}
        >
          <div className="flex items-center gap-3">
            {lesson.icon?.src ? (
              <img
                src={lesson.icon.src}
                alt={lesson.icon.alt || lesson.title}
                className="w-8 h-8 object-contain"
              />
            ) : (
              <BookOpenIcon className="w-8 h-8 text-gray-400" />
            )}
            <div className="flex-1 min-w-0">
              <p className="font-medium text-sm truncate">{lesson.title}</p>
              <p className="text-xs text-gray-500">
                {lesson.pages?.length || 0} pages
              </p>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default LessonsTabContent;
